import { ThemeUICSSObject } from '@apia/theme';
import { focusOutline, spacing } from '../../../../util';
/* IMPORT HERE */
export const form: ThemeUICSSObject = {
  /* PREPEND HERE */

  alignItems: 'end',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  '.textarea__container': {
    position: 'relative',
    width: '100%',
    display: 'flex',
    '.buttons__container': {
      position: 'absolute',
      right: '10px',
      bottom: '10px',
      display: 'flex',
      width: 'auto',
      gap: '8px',
      button: {
        background: 'transparent',
      },
    },
    button: {
      // borderRadius: '50%',
      background: 'white',
      border: 'none',
      color: 'black',
      // height: '50px',
      // width: '50px',
    },
    'button:hover': {
      background: 'palette.background.overlay',
    },
    '.button__content': {
      display: 'flex',
    },
  },
  textarea: {
    height: '150px',
    maxHeight: '30vh',
    width: '100%',
    scrollbarColor: 'transparent',
    flexShrink: 1,
    // resize: 'none',
  },
  'textarea::-webkit-scrollbar': {
    display: 'none',
  },
  '.gpt__buttonsContainer': {
    display: 'none',
    alignItems: 'end',
    gap: 3,
  },

  ul: {
    ml: 6,
    listStyle: 'square',
  },

  '.search_controls': {
    alignItems: 'end',
    justifyContent: 'center',
    display: 'flex',
    gap: 0,
    mx: 'auto',
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    borderRadius: 'panel',
    boxShadow: '0px 2px 6px #0002',
    width: '100%',
    p: spacing(3),

    '&:focus-within': focusOutline,

    '& > *:focus': {
      outline: 'none',
    },
    '.filter_button_box': {
      position: 'relative',
    },
    '.applied_filters_label': {
      position: 'absolute',
      bottom: '21px',
      left: '20px',
      minWidth: '10px',
      maxHeight: '10px',
      border: '2px solid white',
      borderRadius: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'palette.error.main',
    },
  },
  '.searchTextArea': {
    minHeight: '34px',
    height: '34px',
    resize: 'none',
    py: spacing(2),
    background: 'transparent',
    border: 'none',
  },

  '.SearchButton': {
    borderRadius: 'panel',
    height: '34px',
    width: '34px',
    flexShrink: 0,
    background: 'transparent',
    border: 'none',
    color: 'palette.text.primary',
  },
};
